import { isProductionEnvironment } from "~/Context";

export const AUTH_0 = Object.freeze({
  PRODUCTION_DOMAIN: "auth.estrack.com",
  PRODUCTION_CLIENT_ID: "PuqWYHv7aGGioWB0E8SVlK7UuzsaPZ0d",
  PRODUCTION_AUDIENCE: "https://api.equipmentshare.com",
  STAGE_DOMAIN: "staging-auth.estrack.com",
  STAGE_CLIENT_ID: "rOVjKMcQLC7k68FkDNS4NumYZxAPfHiY",
  STAGE_AUDIENCE: "https://staging-api.equipmentshare.com",
} as const);

export type Auth0ApplicationConfigurationType = {
  readonly audience: string;
  readonly clientId: string;
  readonly domain: string;
  readonly redirectUri: string;
};

export const getAuth0ApplicationConfiguration = (): Auth0ApplicationConfigurationType => {
  const isProd = isProductionEnvironment();

  return {
    audience: isProd ? AUTH_0.PRODUCTION_AUDIENCE : AUTH_0.STAGE_AUDIENCE,
    clientId: isProd ? AUTH_0.PRODUCTION_CLIENT_ID : AUTH_0.STAGE_CLIENT_ID,
    domain: isProd ? AUTH_0.PRODUCTION_DOMAIN : AUTH_0.STAGE_DOMAIN,
    redirectUri: `${location.protocol}//${location.host}/e-logs/`,
  };
};
